const PROJECT_NAME = process.env.REACT_APP_PROJECT_NAME || process.env.PROJECT_NAME
const settings = {
  "ichiba-ms-rms-stg": {
    config: {
      apiKey: "AIzaSyBpqifHzeiabZP4mmDOyWFoZRJX68kbGJE",
      authDomain: "ichiba-ms-crm-stg.firebaseapp.com",
      projectId: "ichiba-ms-crm-stg",
      storageBucket: "ichiba-ms-crm-stg.appspot.com",
      messagingSenderId: "743124742400",
      appId: "1:743124742400:web:99380707bb85b2b12203e5",
      measurementId: "G-5H0KWE6NVZ"
    },
    serviceAccount: {
      email:'dev-r-crm@mail.rakuten.com',
      pass:'STG-ichiba-01'
    }
  },
  "ichiba-ms-rms": {
    config: {
      apiKey: "AIzaSyD_jsQgsaV1aXVk8nF0i-NjltZ_U0OFtS4",
      authDomain: "ichiba-ms-crm.firebaseapp.com",
      databaseURL: "https://ichiba-ms-crm.firebaseio.com",
      projectId: "ichiba-ms-crm",
      storageBucket: "ichiba-ms-crm.appspot.com",
      messagingSenderId: "117787278315",
      appId: "1:117787278315:web:14d3b554a3b33bfcbcf7ae",
      measurementId: "G-80KK7RB8PK"
    },
    serviceAccount: {
      email:'dev-r-crm@mail.rakuten.com',
      pass:'PRD-ichiba-01'
    }
  }
}[PROJECT_NAME]

export default settings